jQuery(function ($) {

	const filterSelect = $('#ResourceFilter');
	
	filterSelect.on('change', function(e) {
		insertParam('category', $(this).val());
	});
	
	function insertParam(key, value) {
		
		key = encodeURIComponent(key);
		value = encodeURIComponent(value);
		
		let kvp = document.location.search.substr(1).split('&');
		
		for(var i = 0; i < kvp.length; i++){
			if (kvp[i].startsWith(key + '=')) {
				let pair = kvp[i].split('=');
				pair[1] = value;
				kvp[i] = pair.join('=');
				break;
			}
		}
		
		if(i >= kvp.length){
			kvp[kvp.length] = [key, value].join('=');
		}
		
		// reload page with new params
		document.location.search = kvp.join('&');
		
	}
	
});